/**
 * byok-start-lib.ts — Lối "Tạo nhân viên AI bằng Key của tôi": chọn nhà cung cấp đã bật Key của tôi (Nguồn AI) + model, rồi đi
 * vào ĐÚNG luồng tạo nhân viên AI của eCDP (wizard) với model đặt sẵn — bot giống hệt bot eCDP, chỉ là token model tính vào key
 * của khách. Nguồn (AI của eCDP / Key của tôi) đặt theo nhà cung cấp cho cả tổ chức, nên chỉ nhận nhà cung cấp đang ở Key của tôi.
 */
import type { AiModelEntry, AiProviderSource, AiSources } from '@/lib/ai-credits'
import { AI_PATHS } from '@/lib/ai-khung'

/** Nhà cung cấp dùng được cho lối này: đang ở chế độ "Key của tôi" và đã có key. */
export function byokProviders(sources: AiSources | null | undefined): AiProviderSource[] {
  return (sources?.providers ?? []).filter((p) => p.source === 'byok' && p.byok?.configured)
}

/** Model "Key của tôi" của một nhà cung cấp (cùng thứ tự / tên với ô chọn model ở Nguồn AI). */
export function byokModelsFor(models: AiModelEntry[] | null | undefined, provider: string): { value: string; label: string }[] {
  const seen = new Set<string>()
  const out: { value: string; label: string }[] = []
  for (const m of models ?? []) {
    if (m.provider !== provider || m.source !== 'byok' || seen.has(m.model)) continue
    seen.add(m.model)
    out.push({ value: m.model, label: m.title })
  }
  return out
}

/** Đường vào wizard tạo nhân viên AI với model đặt sẵn. */
export function newBotPathWithModel(provider: string, model: string): string {
  return `${AI_PATHS.newBot}?${new URLSearchParams({ provider, model }).toString()}`
}

/** Đọc model đặt sẵn từ query của wizard (chỉ khi đủ cả hai). */
export function presetModelFromParams(params: URLSearchParams): { provider: string; model: string } | null {
  const provider = params.get('provider')?.trim()
  const model = params.get('model')?.trim()
  return provider && model ? { provider, model } : null
}
